import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Church } from '../shared/interfaces/church.interface';

@Injectable({
  providedIn: 'root'
})
export class ChurchService {
  url = '@cec-api/church/'

  constructor(private http: HttpClient) { }
  get():Promise<any>{
    return this.http.get(this.url).toPromise();
  }

  getById(id: number): Promise<any>{
    return this.http.get(this.url+id).toPromise();
  }

  add(church: Church): Promise<any>{
    return this.http.post(this.url, church).toPromise();
  }

  update(church: Church, id: number): Promise<any>{
    return this.http.put(this.url+id, church).toPromise();
  }

  delete(id:number){
    return this.http.delete(this.url+id).toPromise();
  }

}
